export type SessionsState = {
  expired: boolean;
};

export const initialState: SessionsState = {
  expired: false,
};
